var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.586,
    height: 28.348,
    viewBox: "0 0 28.586 28.348",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feedback",
    transform: "translate(-891 -903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_7186",
    "data-name": "Raggruppa 7186",
    transform: "translate(889 901)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16268",
    "data-name": "Tracciato 16268",
    d: "M20,4H6A3,3,0,0,0,3,7V19.518a3,3,0,0,0,3,3h8.3a1,1,0,0,1,.692.278l6.664,6.392a.5.5,0,0,0,.846-.361V22.518H26a3,3,0,0,0,3-3V14",
    fill: "none",
    stroke: "#283897",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16269",
    "data-name": "Tracciato 16269",
    d: "M28.693,2.586a2,2,0,0,0-2.828,0l-9.572,9.572L16,12.451v2.635a1.5,1.5,0,0,0,1.5,1.5h2.635l.293-.293L30,6.721a2,2,0,0,0,0-2.828ZM18,14.586V13.279l6.639-6.64,1.307,1.307-6.64,6.64Zm9.361-8.054,1.225-1.225L27.279,4,26.054,5.225Z",
    fill: "#283897"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Linea_909",
    "data-name": "Linea 909",
    x2: 9,
    transform: "translate(6 11)",
    fill: "none",
    stroke: "#283897",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_16270",
    "data-name": "Tracciato 16270",
    d: "M6,16h4",
    fill: "none",
    stroke: "#283897",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_409",
    "data-name": "Ellisse 409",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(12 15)",
    fill: "#283897"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIcon);
export default __webpack_public_path__ + "static/media/message_icon.d54555bc856dd327c2120555a7100d03.svg";
export { ForwardRef as ReactComponent };